var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',_vm._b({class:{ 'ebp-card': true }},'b-card',_vm.$attrs,false),[_c('vue-page-transition',[(_vm.loading)?_c('span',{staticClass:"loading"},[_c('spinner-dots')],1):_vm._e()]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }